<template>
  <div class="entry">
    <div class="entry_banner">
      <img
        v-if="$store.state.wWidth > 768"
        src="@/assets/index-banner.png"
        alt
      />
      <img v-else src="@/assets/mobile/IndexBanner_Mobile@2x.png" alt />
      <div
        :class="`childPageTemp_title childPageTemp_title_${$i18n.locale}`"
        style="text-align: right"
      >
        <div>{{ $t("message.entries.home.hzmbTruck") }}</div>
      </div>
    </div>
    <div class="entry_content">
      <EntryBtnGroup>
        <EntryBtn
          v-for="(entry, index) in entries"
          :key="index"
          :localIcon="entry.icon"
          :label="entry.label"
          :locale="true"
          @click="btnClick(entry)"
        ></EntryBtn>
      </EntryBtnGroup>
    </div>
  </div>
</template>

<script>
import EntryBtn from "@/components/EntryBtn.vue";
import EntryBtnGroup from "@/components/EntryBtnGroup.vue";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
export default {
  components: { EntryBtn, EntryBtnGroup },
  data() {
    return {
      loading: false,
      entries: [],
    };
  },
  methods: {
    btnClick(entry) {
      localStorage.setItem("childTempTitle", entry.lanCode);
      this.$router.push(entry.path);
    },
  },
  async created() {
    this.$store.commit("changeServiceType", null);
    const hzmb = await ServiceTypeConfigAPI.get("HZMB");
    const hzmbG = hzmb.find((e) =>
      ["HZMB_G_FIRST", "HZMB_G_RENEW", "HZMB_G_CANCEL"].includes(e.serviceType)
    );
    const hzmbH = hzmb.find((e) =>
      [
        "HZMB_H_FIRST_PERSON",
        "HZMB_H_RENEW_PERSON",
        "HZMB_H_CANCEL_PERSON",
        "HZMB_H_FIRST_COMP",
        "HZMB_H_RENEW_COMP",
        "HZMB_H_CANCEL_COMP",
      ].includes(e.serviceType)
    );
    if (hzmbG) {
      this.entries.push({
        path: "/hzmb-truck-hk",
        icon: "hzmb-g.png",
        label: this.$t("hzmbG.title.hzmbG"),
        lanCode: "hzmbG",
      });
    }
    if (hzmbH) {
      this.entries.push({
        path: "/hzmb-truck-mo",
        icon: "hzmb-h.png",
        label: this.$t("message.entries.home.hzmbH"),
        lanCode: "hzmbH",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.entry {
  margin: auto;
}
.entry_banner {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.entry_banner img {
  width: 100%;
  // max-width: 1440px;
  display: block;
  margin: auto;
}
.childPageTemp_title {
  // justify-content: flex-end;
}
.entry_content {
  // max-width: 1440px;
  margin: auto;
  min-height: 450px;
  padding-top: 56px;
  padding-bottom: 45px;
  background: #f9f9f9;
}

@media screen and (max-width: 767px) {
  .entry_content {
    padding-top: 24px;
  }
}
</style>
